import { defineStore } from "pinia";
import OemApiService from "../../oemApiService";
export const useMaintenanceScheduleStore = defineStore("maintenanceScheduleStore", {
    state: () => ({
        apiUrlModels: "api/oemssaa/subaru/maintenance-schedule-models",
        apiUrlTrims: "api/oemssaa/subaru/maintenance-schedule-trims",
        apiUrlMaintenanceSchedules: "api/oemssaa/subaru/maintenance-schedule",
        questionYearAnswers: undefined,
        questionYearAnswer: undefined,
        questionModelAnswers: undefined,
        questionModelAnswer: undefined,
        questionModelAnswerPhotoUrl: undefined,
        questionTrimAnswers: undefined,
        questionTrimAnswer: undefined,
        questionMileageAnswer: undefined,
        maintenanceScheduleNormal: undefined,
        maintenanceScheduleSevere: undefined,
        selectedVehicle: undefined,
    }),
    getters: {
        apiUrlModel: (state) => {
            return `${state.apiUrlModels}?year=${state.questionYearAnswer}`;
        },
        apiUrlTrim: (state) => {
            return `${state.apiUrlTrims}?year=${state.questionYearAnswer}&model=${state.questionModelAnswer}`;
        },
        apiUrlMaintenanceScheduleNormal: (state) => {
            return `${state.apiUrlMaintenanceSchedules}?year=${state.questionYearAnswer}&model=${state.questionModelAnswer}&trim=${state.questionTrimAnswer}&mileage=${state.questionMileageAnswer}&scheduleType=n`;
        },
        apiUrlMaintenanceScheduleSevere: (state) => {
            return `${state.apiUrlMaintenanceSchedules}?year=${state.questionYearAnswer}&model=${state.questionModelAnswer}&trim=${state.questionTrimAnswer}&mileage=${state.questionMileageAnswer}&scheduleType=s`;
        },
    },
    actions: {
        async getYears() {
            const vehicleYears = document.getElementById("subaruMaintenanceYears");
            if (vehicleYears) {
                const years = JSON.parse(vehicleYears.dataset.years);
                this.questionYearAnswers = years;
            }
        },
        async getModels() {
            if (!this.questionModelAnswers &&
                this.questionYearAnswer !== undefined) {
                const results = await OemApiService.get(this.apiUrlModel);
                this.questionModelAnswers = [];
                results?.Models.forEach((element) => {
                    this.questionModelAnswers.push({
                        name: element.Model,
                        modelPhotoUrl: element.ModelPhotoUrl,
                    });
                });
            }
        },
        async getTrims() {
            if (!this.questionTrimAnswers &&
                this.questionModelAnswers !== undefined &&
                this.questionYearAnswer !== undefined) {
                const results = await OemApiService.get(this.apiUrlTrim);
                this.questionTrimAnswers = [];
                results?.trims.forEach((element) => {
                    this.questionTrimAnswers.push(element);
                });
            }
        },
        async getMaintenanceSchedule() {
            this.selectedVehicle = {
                photoUrl: this.questionModelAnswerPhotoUrl,
                year: this.questionYearAnswer.toString(),
                model: this.questionModelAnswer,
                trim: this.questionTrimAnswer,
                mileage: this.questionMileageAnswer.toString(),
            };
            this.clearMaintenanceSchedule();
            await OemApiService.get(this.apiUrlMaintenanceScheduleNormal).then((normalSchedule) => {
                this.maintenanceScheduleNormal = normalSchedule;
            });
            await OemApiService.get(this.apiUrlMaintenanceScheduleSevere).then((severeSchedule) => {
                this.maintenanceScheduleSevere = severeSchedule;
            });
        },
        clearMaintenanceSchedule() {
            this.maintenanceScheduleNormal = undefined;
            this.maintenanceScheduleSevere = undefined;
        },
        updateQuestionYearAnswer() {
            this.questionModelAnswers = undefined;
            this.getModels();
            this.questionTrimAnswers = undefined;
            this.questionTrimAnswer = undefined;
            this.questionMileageAnswer = undefined;
        },
        updateQuestionModelAnswer(answer, imageUrl) {
            this.questionModelAnswer = answer;
            this.questionModelAnswerPhotoUrl = imageUrl;
            this.questionTrimAnswers = undefined;
            this.questionTrimAnswer = undefined;
            this.getTrims();
            this.questionMileageAnswer = undefined;
        },
        updateQuestionTrimAnswer() {
            this.questionMileageAnswer = undefined;
        },
        getNewVehicle() {
            this.clearAllQuestions();
            this.clearMaintenanceSchedule();
        },
        clearAllQuestions() {
            this.questionYearAnswer = undefined;
            this.questionModelAnswer = undefined;
            this.questionModelAnswers = undefined;
            this.questionTrimAnswer = undefined;
            this.questionTrimAnswers = undefined;
            this.questionMileageAnswer = undefined;
        },
    },
});
